<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup Area
 * @created at      :   2024/05/22
 * @created by      :   ANS902 – quanlh@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import store from '@/store';
import template from './template.html';
import './style.scss';
import { mapState, mapMutations, mapActions } from 'vuex';
import PtjPopupBankAccount from '@/views/popupSearch/ptj_popup_bank_account/store';
/**
 * Define component for popup Fab040120i
 */
import helpers from '@/utils/helpers';

var PtjPopupBank = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PtjPopupBankAccount')) {
            store.registerModule('PtjPopupBankAccount', PtjPopupBankAccount);
        }
    },
    created() {
        this.onInitScreen();
        this.onSearchItem();
    },
    data() {
        return {};
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName', 'onReferValueOther'],
    computed: {
        ...mapState('PtjPopupBankAccount', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PtjPopupBankAccount', ['searchAreaInfo']),
        ...mapMutations('PtjPopupBankAccount', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.searchAreaInfo(this.data);
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchAreaInfo(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseItem(data) {
            this.$emit('onReferModelValue', data.bank_cd);
            this.$emit('onReferValueName', data.bank_name);
            this.$emit('onReferValueOther', data);
            this.$emit('close');
        }
    }
};
export default PtjPopupBank;
</script>
